/**
 * 表单控件的校验的公共方法
 * wangz 
 * 2018.3.9
 */

"use strict"

// 校验规则
function FormVerify() {
    // 1 代表 2009-09-30 , 2 代表 2009/09/30 , 3 代表 20090930 , 4 代表 2009年09月30日
    this.regDate3 = /^[1-2]\d{6,7}$/;
    this.regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    this.regPhone = /^((\(\d{1,5}\))|(\d{1,5}\-))?(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(-\d{1,5})?$/;
    this.regPhones = /^(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(-\d{1,5})?([,|;](\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(-\d{1,5})?)*$/;
    this.regMobile = /^((\(\d{3}\))|(\d{3}\-))?1[1-9]\d{9}$/;
    this.regUrl = /^http:\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/;	//';
    this.className = /^([_a-z0-9]+\.)*[A-Z][_A-Za-z0-9]+$/;
    this.regIdCard15 = /^\d{15}(\d{2}[A-Za-z0-9])?$/;
    this.regIdCard18 = /^\d{17}(?:\d|x|X)$/;
    this.regMoney = /^[-\+]?\d+(\.\d{0,2})?$/;
    this.regNumber = /^\d+$/;
    this.regZip = /^[0-9]\d{5}$/;
    this.regQQ = /^[1-9]\d{3,9}$/;
    this.regInteger = /^[-\+]?\d+$/;
    this.regDouble = /^[-\+]?\d+(\.\d+)?$/;
    this.regEnglish = /^[A-Za-z]+$/;
    this.regEnglish2 = /^[A-Za-z\s]+$/;
    this.regChinese = /^[\u0391-\uFFE5]+$/;
    this.regUnSafe = /^(([A-Z]*|[a-z]*|\d*|[-_\~!@#\$%\^&\*\.\(\)\[\]\{\}<>\?\\\/\'\"]*)|.{0,5})$|\s/;	//';
    this.regNotChar = /^[^`~!@#$%^&*()+=|\\\][\]\{\}:;'\,.<>/?]{1}[^`~!@$%^&()+=|\\\][\]\{\}:;'\,.<>?]{0,19}$/;
    this.regChar = /[(\/)(\\)(')(")(<)(>)]/g;		//';
};

let FormVerifyObj = new FormVerify();

// required，max,min,dataType,pattern,patternPrompt,validator
function sgiFormCtlCheck(rule, value, parameters) {
    var isEmpty = (value === '' || value === null || typeof (value) === "undefined");
    //校验是否为空
    if (rule.required === true) {
        if (isEmpty) {
            return '请输入,不允许为空';
        }
    }

    if (isEmpty) {
        return '';
    }

    //校验最长最小输入
    if (rule.maxL > 0) {
    // if (typeof rule.maxL === "number") {
        if (value.length > rule.maxL) {
            return '最多输入【' + rule.maxL + '】个字符';
        }
    }
    if (rule.minL > 0) {
    // if (typeof rule.minL === "number") {
        if (value.length < rule.minL) {
            return '至少输入【' + rule.minL + '】个字符';
        }
    }
    //校验最大最小值
    // if (rule.maxV > 0) {
    if (typeof rule.maxV === "number") {
        if (parseFloat(value) > rule.maxV) {
            return '最大值【' + rule.maxV + '】';
        }
    }
    // if (rule.minV > 0) {
    if (typeof rule.minV === "number") {
        if (parseFloat(value) < rule.minV) {
            return '最小值【' + rule.minV + '】';
        }
    }

    //常用类型校验
    if (rule.dataType !== '' && rule.dataType !== null && typeof (rule.dataType) !== "undefined") {
        var msg = _checkDataType(value, rule.dataType);
        if (msg !== '' && msg !== null && typeof (msg) !== "undefined") {
            return msg;
        }
    }

    //自定义校验方法
    if (rule.validator !== '' && rule.validator !== null && typeof (rule.validator) !== "undefined") {
        var msg = rule.validator(value, rule, page);
        if (msg !== '' && msg !== null && typeof (msg) !== "undefined") {
            return msg;
        }
    }

    // 自定义校验
    if (rule.cstmValid && typeof rule.cstmValid === "function") {
        try {
            tool.sgiLogger.log("自定义校验");
            let { module, objFct } = parameters;
            return rule.cstmValid(module, objFct, value);
        } catch (error) {
            tool.sgiLogger.error("custom verification error :", error);
        }
    }

    return '';
}

// 检查域的有效性
function _checkDataType(str, dataType) {
    for (var x = _isValidMethod.length - 1; x >= 0; x--) {
        var c = _isValidMethod[x];
        if (c.type == dataType) {
            return c.isValid(str);
        }
    }

    return '未知的数据类型[' + dataType + ']';
};

// 有效性函数
// isValid=检查数据有效性
// checkValid=检查数据是否越界
var _isValidMethod = [
    {
        type: 'int',
        isValid: function (str) { if (FormVerifyObj.regInteger.test(str) == false) return "请输入整数!"; }
    },
    {
        type: 'double',
        isValid: function (str) { if (FormVerifyObj.regDouble.test(str) == false) return "请输入Double数据，比如：55.069!"; }
    },
    {
        type: 'money',
        isValid: function (str) { if (FormVerifyObj.regMoney.test(str) == false) return "请输入金额，比如：2355.00!"; }
    },
    {
        type: "email",
        isValid: function (str) { if (FormVerifyObj.regEmail.test(str) == false) return "请输入电子邮件地址!"; }
    },
    {
        type: "idcard",
        isValid: isIdCard
    },
    {
        type: "idcard18",
        isValid: isIdCard
    },
    {
        type: "phone",
        isValid: function (str) { if (FormVerifyObj.regPhone.test(str) == false) return "请输入电话号码!"; }
    },
    {
        type: "phones",
        isValid: function (str) { if (FormVerifyObj.regPhones.test(str) == false) return "请输入电话号码，[,]分割!"; }
    },
    {
        type: "mobile",
        isValid: function (str) { if (FormVerifyObj.regMobile.test(str) == false) return "请输入手机号码!"; }
    },
    {
        type: "zip",
        isValid: function (str) { if (FormVerifyObj.regZip.test(str) == false) return "请输入六位数字的邮政编码!"; }
    },
    {
        type: "url",
        isValid: function (str) { if (FormVerifyObj.regUrl.test(str.toLowerCase()) == false) return "请输入HTTP地址!"; }
    },
    {
        type: "classname",
        isValid: function (str) { if (FormVerifyObj.className.test(str) == false) return "请输入有效的类名称!"; }
    },
    {
        type: "qq",
        isValid: function (str) { if (FormVerifyObj.regQQ.test(str) == false) return "请输入QQ号!"; }
    },
    {
        type: "number",
        isValid: function (str) { if (FormVerifyObj.regNumber.test(str) == false) return "请输入数字!"; }
    },
    {
        type: "汉字",
        isValid: function (str) { if (FormVerifyObj.regChinese.test(str) == false) return "请输入汉字!"; }
    },
    {
        type: "字母",
        isValid: function (str) { if (FormVerifyObj.regEnglish2.test(str) == false) return "请输入字母或空格!"; }
    }
];


// 检测身份证号码输入的合法性	15位或者18位的数字
function isIdCard(str) {
    if (str.length != 18 && str.length != 15) return "请输入有效的身份证号码!";
    var reg = (str.length == 18) ? FormVerifyObj.regIdCard18 : FormVerifyObj.regIdCard15;
    if (reg.test(str) == false) {
        return "请输入有效的身份证号码!";
    }

    // 日期
    var y = '';
    var m = '';
    var d = '';
    if (str.length == 18) {
        y = str.substr(6, 4);
        m = str.substr(10, 2);
        d = str.substr(12, 2);
    } else if (str.length == 15) {
        y = "19" + str.substr(6, 2);
        m = str.substr(8, 2);
        d = str.substr(10, 2);
    }

    if (checkYearMonthDay(y, m, d) == false) {
        return "日期的取值范围不正确!";
    }

    // 强制检查身份证的校验位
    var checkValue = strictCheckIdcard(str);
    if (checkValue != null) {
        return "请输入有效的身份证号码!";
    }
};


// 检查日期中年月日的合法性
function checkYearMonthDay(years, months, days) {
    var reg = /^\d+$/;

    //处理年
    if (years.length != 4 || years == 0) return false;
    if (!reg.test(years)) return false;

    var leapyear = ((parseInt(years) % 4 == 0 && parseInt(years) % 100 != 0) || parseInt(years) % 400 == 0);

    //处理月
    if (!months || months == 0) return false;
    if (!reg.test(months)) return false;
    var mon = parseInt(months, 10);
    if (mon > 12) return false;

    //处理日
    if (!days || days == 0) return false;
    if (!reg.test(days)) return false;

    var mdays = [29, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (mon == 2 && leapyear) mon = 0;
    if (days > mdays[mon]) return false;

    return true;
};

// 严格检查身份证的有效性
function strictCheckIdcard(id) {
    // 只检查18位身份证
    if (id.length != 18) {
        return null;
    }

    var checkValue = getIdCheckNumber(id);
    var iv = id.substring(17).toUpperCase();
    if (checkValue != iv) {
        return checkValue;
    }

    return null;
};

function getIdCheckNumber(id) {
    var arrVerifyCode = "1,0,X,9,8,7,6,5,4,3,2".split(",");
    var wi = "7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2".split(",");

    var checkNumber = 0;
    for (var i = 0; i < 17; i++) {
        checkNumber = checkNumber + parseInt(id.substring(i, i + 1)) * wi[i];
    }

    var modValue = checkNumber % 11;
    var checkValue = arrVerifyCode[modValue];

    return checkValue;
};

export { sgiFormCtlCheck };
export default { sgiFormCtlCheck };


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiFormCtlValidator.js